// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  Box,
  CheckboxField,
  Flex,
  Image,
  Link,
  Typography,
} from '@iheartjane/reefer';
import type { Row } from '@tanstack/react-table';
import type { MouseEventHandler } from 'react';
import { useLocation } from 'react-router';

import type { MenuProductForProductsTable } from '@jane/business-admin/types';
import { useImage } from '@jane/shared/components';

import type { ProductTableFeatures } from './productTableFeatures';

const StyledTypography = styled(Typography)({
  '@supports (-webkit-line-clamp: 2)': {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const StyledFlex = styled(Flex)({
  maxWidth: 400,
  wordWrap: 'break-word',
  whiteSpace: 'normal',
});

export const ProductCell = ({
  handleClick,
  isBulkEditTable = false,
  row,
}: {
  handleClick: MouseEventHandler<HTMLInputElement>;
  isBulkEditTable?: boolean;
  row: Row<ProductTableFeatures, MenuProductForProductsTable>;
}) => {
  const { imageSrc } = useImage(row.original);
  const { pathname } = useLocation();

  const url = `${pathname}/${row.original.id}`;

  return (
    <Link
      to={url}
      onClick={(event) => {
        event.stopPropagation();
      }}
      variant="minimal"
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        ml={64}
        maxWidth={400}
      >
        <StyledFlex alignItems="center">
          {isBulkEditTable ? (
            <Box pr={24}>
              <CheckboxField
                label={`${row.original.id}-checkbox`}
                name={`${row.original.id}-checkbox`}
                labelHidden
                checked={row.getIsSelected()}
                onClick={handleClick}
              />
            </Box>
          ) : null}
          <Image
            height="48px"
            width="48px"
            border
            borderRadius="12px"
            src={imageSrc}
            altText={row.original.name}
          />
          <StyledTypography
            variant="body-semibold"
            mx={24}
            {...{ title: row.original.name }}
          >
            {row.original.name}
          </StyledTypography>
        </StyledFlex>
      </Flex>
    </Link>
  );
};
